import { forwardRef, Ref } from "react";
import styles from "./VideoBottomLayout.module.css";

const BottomVideoWrapper = forwardRef<HTMLDivElement, {}>(function BottomVideoWrapper(_, ref) {
	return <div className={styles.bottomVideo} ref={ref} />;
});

export default function VideoBottomLayout({
	mainVideoRef,
	bottomVideoRefs,
}: {
	mainVideoRef: Ref<HTMLDivElement>;
	bottomVideoRefs: Ref<HTMLDivElement>[];
}) {
	return (
		<div className={styles.bottomLayout}>
			<div className={styles.mainPanel} ref={mainVideoRef} />
			{bottomVideoRefs.length > 1 ? (
				<div className={styles.bottomPanel}>
					{bottomVideoRefs.map((ref, index) => (
						<BottomVideoWrapper key={index} ref={ref} />
					))}
				</div>
			) : (
				<div className={styles.mainPanel} ref={bottomVideoRefs[0]} />
			)}
		</div>
	);
}
